import React from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import Input from '../../components/Input';
import ItemsList from './ItemsList';
import makeBodyText from '../../utils/makeText';
import makeIconName from '../../utils/makeIconName';
import { ICONS } from '../../constants/icons';
class DropDown extends React.Component {
    constructor(props) {
        super(props);
        this._handleEnter = () => {
            this.setState({
                isOpen: true
            });
        };
        this._handleOut = (e) => {
            if (this._ref.current.contains(e.relatedTarget)) {
                return;
            }
            this.setState({
                isOpen: false,
                isSearchStarted: false
            });
        };
        this._handleChange = (e) => {
            var _a;
            const { onClear } = this.props;
            this.setState((prevState) => {
                var _a, _b, _c, _d;
                return ({
                    matchValue: ((_a = e.target) === null || _a === void 0 ? void 0 : _a.value) || '',
                    isSearchStarted: prevState.matchValue.length !== ((_c = (_b = e.target) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length),
                    selectedItem: !((_d = e.target) === null || _d === void 0 ? void 0 : _d.value) ? '' : prevState.selectedItem
                });
            });
            if (!e || ((_a = e.target) === null || _a === void 0 ? void 0 : _a.value.length) === 0) {
                onClear && onClear();
            }
        };
        this._handleSelect = (e) => {
            const { onElemClick } = this.props;
            this.setState({
                isOpen: false,
                selectedItem: e.target.id,
                matchValue: e.target.dataset.label
            });
            onElemClick(e);
        };
        this._handleAutofill = (e) => {
            const filledValue = e.target.value;
            const { list } = this.state;
            if (!list) {
                return;
            }
            const foundItem = list.find(
            /*
              The following line looks for either the label or ID to match because of state inputs-- in Chrome the filled
              value is "AK" but we present "Alaska" to the user, for some reason. Because of this in order to remain
              maximally flexible in a core component, I want to match on both values. Since the ID should be unique, and the
              label should _also_ be arguably unique, this is small potatoes overall.
             */
            (item) => item.label === filledValue || item.id === filledValue);
            if (!foundItem) {
                return;
            }
            this._handleSelect({
                target: {
                    id: foundItem.id,
                    dataset: {
                        label: foundItem.label
                    }
                }
            });
        };
        this._getItemLabel = () => {
            const { selectedItem, list } = this.state;
            if (!list) {
                return null;
            }
            const { label } = list.find((item) => item.id === selectedItem) || {};
            return label;
        };
        this._renderSelect = () => {
            const { isOpen, selectedItem } = this.state;
            const { input, isFullWidth, ID } = this.props;
            const wrapperClassNames = classnames({
                [styles.fullWidth]: isFullWidth,
                [styles.selectInput]: true
            });
            const buttonClassNames = classnames({
                [styles.withDarkBcg]: input.isDarkBcg,
                [styles.selected]: selectedItem,
                [styles.withError]: input.isError
            });
            const selectedItemLabel = this._getItemLabel();
            return (React.createElement("div", { className: wrapperClassNames },
                React.createElement("button", { tabIndex: -1, type: 'button', onClick: this._handleEnter, onFocus: this._handleEnter, onBlur: this._handleOut, className: buttonClassNames, id: ID, "data-testid": 'dropdownButton' },
                    React.createElement("div", null,
                        selectedItemLabel && (React.createElement("div", { className: `${makeBodyText('M')} ${styles.label} ${input.isError ? styles.withError : ''}` }, input.label)),
                        React.createElement("div", { className: `${makeBodyText('L')} ${styles.text}`, "data-testid": 'selectedValue' }, selectedItemLabel || input.label)),
                    React.createElement("i", { className: `${makeIconName(isOpen ? ICONS.x24.arrow_up : ICONS.x24.arrow_down, 'x24')} ${styles.icon}` })),
                React.createElement("input", { tabIndex: -1, "aria-hidden": true, className: styles.nativeInput, value: selectedItemLabel || '', autoComplete: input.autoComplete || 'off', onChange: this._handleAutofill }),
                input.description && (React.createElement("p", { id: `${input.name}-err-text`, className: `${makeBodyText('S')} ${styles.description} ${input.isError ? styles.withError : ''}` }, input.description))));
        };
        this._renderInput = () => {
            const { isOpen, matchValue, isSearchStarted } = this.state;
            const { input, isFullWidth, ID, isDisabled, autofocus } = this.props;
            return (React.createElement(Input, { autoFocus: autofocus, name: input.name, id: ID, isDisabled: isDisabled, onFocus: this._handleEnter, onBlur: this._handleOut, onChange: this._handleChange, isControlledMode: true, isFullWidth: isFullWidth, isError: input.isError, description: input.description, value: isSearchStarted ? matchValue : this._getItemLabel() || matchValue, type: 'text', label: input.label, placeholder: input.placeholder, withIcon: true, iconName: isOpen ? ICONS.x24.arrow_up : ICONS.x24.arrow_down, isDarkBcg: input.isDarkBcg }));
        };
        this._renderList = () => {
            const { isOpen, list, matchValue, selectedItem, isSearchStarted, suggestionOption } = this.state;
            const { textSize } = this.props;
            if (!isOpen || !list) {
                return null;
            }
            return (React.createElement(ItemsList, { parentRef: this._ref, suggestionOption: suggestionOption, itemsList: list, isSearchStarted: isSearchStarted, onElemClick: this._handleSelect, textSize: textSize, matchValue: matchValue, selectedItem: selectedItem }));
        };
        this.state = {
            isOpen: false,
            isSearchStarted: false,
            selectedItem: null,
            matchValue: '',
            list: null,
            suggestionOption: null
        };
        this._ref = React.createRef();
    }
    componentDidUpdate(prevProps) {
        const { preSelectedItem } = this.props;
        const { selectedItem } = this.state;
        if (prevProps.preSelectedItem !== preSelectedItem && !selectedItem) {
            this.setState({
                selectedItem: preSelectedItem
            });
        }
    }
    componentDidMount() {
        const { itemsList, preSelectedItem, suggestionOption } = this.props;
        this.setState({
            list: itemsList,
            selectedItem: preSelectedItem || null,
            suggestionOption
        });
    }
    render() {
        const { isOpen } = this.state;
        const { isWithoutSearch, isFullWidth } = this.props;
        const classes = classnames({
            [styles.dropDownWrap]: true,
            [styles.fullWidth]: isFullWidth,
            [styles.notOpened]: !isOpen
        });
        return (React.createElement("div", { onBlur: this._handleOut, ref: this._ref, className: `${classes} dropDownField` },
            isWithoutSearch ? this._renderSelect() : this._renderInput(),
            this._renderList()));
    }
}
export default DropDown;
